import { render, staticRenderFns } from "./BtnAtualizarMovimento.vue?vue&type=template&id=fec22dd2"
import script from "./BtnAtualizarMovimento.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarMovimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports